import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchPartnerConfig } from '../../../../reducers/Auth/actions';
import AppBadge from '../../../../components/AppBadge';

import './index.scss';

export default ({
  title,
  marketplacePartner,
  userDetails,
  marketplacePartnerData,
}) => {
  const dispatch = useDispatch();
  const { partnerConfig } = useSelector(({ AuthReducer }) => AuthReducer);
  
  useEffect(() => {
    if (marketplacePartner && marketplacePartner !== 'zorba') {
      dispatch(fetchPartnerConfig(marketplacePartner));
    }
  }, [marketplacePartner, dispatch]);
  
  const buyerLogoUrl = userDetails?.defaultOrganiation?.logoUrl;
  const marketPlaceLogoUrl =
    marketplacePartner === 'zorba' || marketplacePartnerData?.name === 'Zorba'
      ? ''
      : partnerConfig?.logoUrl ||
        marketplacePartnerData?.logoUrl;

  return (
    <>
      {marketPlaceLogoUrl ? (
        <div className={`marketplace-container ${marketplacePartner}`}>
          <img src={marketPlaceLogoUrl} alt="Marketplace" className="logo" />
          <div className="powered-by">
            <span>Powered by</span>
            <img
              src="https://res.cloudinary.com/dyqquolic/image/upload/v1675256922/zorba-logo-black_xwagzk.svg"
              alt="Zorba"
              className="brand"
            />
          </div>
        </div>
      ) : (
        <div className="logo">
          <img
            alt="logo"
            width={100}
            src="https://res.cloudinary.com/dyqquolic/image/upload/v1675256922/zorba-logo-black_xwagzk.svg"
          />
          {buyerLogoUrl && <img alt="logo" width={100} src={buyerLogoUrl} />}
          {!marketPlaceLogoUrl && <AppBadge title={title} />}
        </div>
      )}
    </>
  );
};
